module.exports = __webpack_public_path__ + "img/img_sub_ser_consulting01.0d84a577.svg";